'use client'
import { ChatBubbleLeftRightIcon } from '@heroicons/react/24/solid'
import { getWhatsAppUrl } from '../../../../config/contact';

export default function CTABanner() {
  return (
    <div className="bg-gradient-to-r from-primary-600 via-primary-500 to-accent-500 py-16 sm:py-20">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="relative rounded-2xl bg-white/10 backdrop-blur-xl shadow-2xl overflow-hidden">
          {/* Decorative elements */}
          <div className="absolute -top-24 -right-24 w-80 h-80 bg-primary-500/20 rounded-full blur-2xl" />
          <div className="absolute -bottom-24 -left-24 w-80 h-80 bg-accent-500/20 rounded-full blur-2xl" />
          <div className="relative px-6 py-12 sm:py-16 sm:px-12 text-center">
            <h2 className="text-3xl sm:text-4xl md:text-5xl font-extrabold tracking-tight text-white leading-tight mb-6">
              Say Bye-Bye to Paper Menus.<br />
              Say Hi to <span className="text-transparent bg-clip-text bg-gradient-to-r from-highlight-400 to-white">ScanMaadi.</span>
            </h2>
            <div className="mt-8 mb-4 flex justify-center">
              <a
                href={getWhatsAppUrl()}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center px-6 py-4 border border-transparent text-base font-medium rounded-xl text-primary-600 bg-white hover:bg-background-50 shadow-lg transform transition duration-300 hover:scale-105"
              >
                <ChatBubbleLeftRightIcon className="h-6 w-6 mr-2 text-accent-500" />
                Chat on WhatsApp
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="w-5 h-5 ml-2">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M13.5 4.5 21 12m0 0-7.5 7.5M21 12H3" />
                </svg>
              </a>
            </div>
            <p className="text-white/90 text-lg mt-4">
              Get your digital menu live within 48 hours!
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}